import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthenticationCtlService } from '../api/services';
import { ChangePasswdDto } from '../api/models';
import { ActivatedRoute, Router } from '@angular/router';
import * as bootstrap from 'bootstrap';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-password',
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './password.component.html',
  styleUrl: './password.component.css'
})
export class PasswordComponent  implements OnInit{



  clearPassword =false;
  clearNewPassword = false;
  changeForm:FormGroup;
  resetForm: FormGroup;
  isChangePasswd:boolean=false;
  username:string='';
  message:string='';
  method?:string;
  messageType:string='';
  isVersusPay:boolean;

  constructor(private formBuilder:FormBuilder,
    private authService:AuthenticationCtlService,
    private router:Router,
    private activeRoute:ActivatedRoute
  ){
    this.isVersusPay=environment.isVersusPay;
    this.changeForm = this.formBuilder.group({
      oldPassword:['',Validators.required],
      newPassword:['',[Validators.required,Validators.minLength(8)]],
      confPassword:['',[Validators.required,Validators.minLength(8)]],
      confirmCheck:['',Validators.required]
    });
    this.resetForm = this.formBuilder.group({
      username:['',Validators.required]
    });
  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(par=>{
      this.method = par['method'];
      console.log(this.method);
      if(this.method =='change'){
        this.messageType='Changement de mot de passe';
        this.isChangePasswd =true;
      }else {
        this.messageType='Rénitialisation de mot de passe';
        this.isChangePasswd =false;
      }
    });
    this.message ='';
  }

  checkConfPassword(){
    let form = this.changeForm.value;
    this.changeForm.controls['confirmCheck'].setValue('');
    if(form.newPassword.length>0 && form.newPassword ==form.confPassword){
      this.changeForm.controls['confirmCheck'].setValue('OK');
    }

  }
  onChangePasswd(){

    let form = this.changeForm.value;
    let dto:ChangePasswdDto ={
      password:form.oldPassword,
      newPassword:form.newPassword
    };
    this.authService.changePassword(
      dto
    ).subscribe({
      next:()=>{
        this.message='Votre mot de passe est modifié avec succés,Veuillez vous reconnecter vous avec le nouveau.';
        const modAdd = new bootstrap.Modal('#modPassword',{});
        modAdd.show();
        
      },
      error:(err)=>{
        this.message = err.error.message;
      }
    });

  }
  onResetPasswd(){
    let form= this.resetForm.value;
    this.authService.resetPassword(
      form.username
    ).subscribe({
      next:()=>{
        this.message='Votre mot de passe a été rénitialisé, Consultez votre email et vous connecter';
        const modAdd = new bootstrap.Modal('#modPassword',{});
        modAdd.show();
        
      },
      error:(err)=>{
        this.message = err.error.message;
      }
    });
  }
  onConnect(){
    this.router.navigateByUrl('/login');
  }
  onShowOldPassword(){
    console.log('show');
    this.clearPassword =!this.clearPassword;
    var pass = document.getElementById('oldPassword');
    if(this.clearPassword){
      pass?.setAttribute('type','text');
    }else{
      pass?.setAttribute('type','password');
    }
  }
  onShowNewPassword(){
    console.log('show');
    this.clearNewPassword =!this.clearNewPassword;
    var pass = document.getElementById('newPassword');
    var conf = document.getElementById('confPassword');
    if(this.clearNewPassword){
      pass?.setAttribute('type','text');
      conf?.setAttribute('type','text');
    }else{
      pass?.setAttribute('type','password');
      conf?.setAttribute('type','password');
    }
  }
}
